import script from "./mobile-app-link.vue?vue&type=script&lang=ts&setup=true"
export * from "./mobile-app-link.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__